import { componentSizes } from '@/theme/componentSizes';
import { s, tableTokens } from '@/theme/tokens';
import type { SxProps, Theme } from '@mui/material/styles';

export const dataGridChromeSx: SxProps<Theme> = {
  '& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader': {
    px: s(tableTokens.cellPadding.x),
    py: s(tableTokens.cellPadding.y),
    display: 'flex',
    alignItems: 'center',
  },
  '& .MuiDataGrid-columnHeaderDraggableContainer': {
    paddingLeft: s(tableTokens.cellPadding.x),
    paddingRight: s(tableTokens.cellPadding.x),
  },
  '& .MuiDataGrid-columnHeaderTitleContainer': {
    paddingLeft: s(tableTokens.cellPadding.x),
    paddingRight: s(tableTokens.cellPadding.x),
  },
  '& .MuiDataGrid-columnHeaderTitleContainerContent': {
    paddingLeft: s('xxs'),
    paddingRight: s('xxs'),
  },
  '& .MuiDataGrid-cellContent': {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    paddingLeft: s(tableTokens.cellPadding.x),
    paddingRight: s(tableTokens.cellPadding.x),
  },
  '& .MuiDataGrid-footerContainer': {
    minHeight: `${componentSizes.dataGrid.footerHeight}px`,
    height: `${componentSizes.dataGrid.footerHeight}px`,
    maxHeight: `${componentSizes.dataGrid.footerHeight}px`,
    paddingLeft: s('xxs'),
    paddingRight: s('none'),
    paddingTop: s('none'),
    paddingBottom: s('none'),
    boxSizing: 'border-box',
    overflow: 'hidden',
  },
  '& .MuiTablePagination-toolbar': {
    minHeight: `${componentSizes.dataGrid.footerHeight}px`,
    height: `${componentSizes.dataGrid.footerHeight}px`,
    maxHeight: `${componentSizes.dataGrid.footerHeight}px`,
    paddingLeft: s('xxs'),
    paddingRight: s('none'),
    paddingTop: 0,
    paddingBottom: 0,
    overflow: 'hidden',
  },
  '& .MuiTablePagination-spacer': {
    flex: '1 1 100%',
  },
  '& .MuiTablePagination-selectLabel': {
    margin: 0,
    transform: 'translateY(-2px)',
  },
  '& .MuiTablePagination-input': {
    marginLeft: s('xs'),
    marginRight: s('xs'),
  },
  '& .MuiTablePagination-select.MuiSelect-select': {
    transform: 'translateY(1px)',
  },
  '& .MuiTablePagination-displayedRows': {
    marginLeft: s('sm'),
    marginRight: s('xs'),
  },
  '& .MuiTablePagination-actions': {
    marginLeft: s('sm'),
    gap: 0,
  },
  '& .MuiTablePagination-actions .MuiIconButton-root': {
    margin: 0,
    minWidth: s('2xl'),
    width: s('2xl'),
    height: s('2xl'),
    padding: s('none'),
  },
};
